import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-d-flex p-flex-row p-jc-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Tree = _resolveComponent("Tree")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "p-fluid kn-dialog--toolbar--primary",
    contentStyle: _ctx.schedulerDocumentsSelectionDialogDescriptor.dialog.style,
    visible: _ctx.visible,
    modal: true,
    closable: false
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-0 p-col-12" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('managers.scheduler.selectDocument')), 1)
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_Button, {
          class: "kn-button kn-button--primary",
          onClick: _ctx.closeDialog
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_Button, {
          class: "kn-button kn-button--primary",
          onClick: _ctx.addDocument
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.add')), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_Tree, {
        id: "document-tree",
        value: _ctx.nodes,
        selectionMode: "single",
        selectionKeys: _ctx.selectedDocumentsKeys,
        "onUpdate:selectionKeys": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedDocumentsKeys = $event)),
        metaKeySelection: false,
        filter: true,
        filterMode: "lenient",
        onNodeSelect: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setSelectedDocument($event))),
        onNodeUnselect: _ctx.removeSelectedDocument,
        onNodeExpand: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setOpenFolderIcon($event))),
        onNodeCollapse: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setClosedFolderIcon($event)))
      }, null, 8, ["value", "selectionKeys", "onNodeUnselect"])
    ]),
    _: 1
  }, 8, ["contentStyle", "visible"]))
}